import React from "react";
import { Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import FormTextInput from "src/_common/components/form-elements/textinput/formTextInput";
import { useUserApi } from "src/_common/hooks/actions/user/appUserApiHook";
import { useAppUserAction } from "src/_common/hooks/actions/user/appUserActionHook";
import moment from "moment";
import DateInput from "src/_common/components/form-elements/datepicker/dateInput";
import { DATE_FORMAT } from "src/_config";
import ReactInputMask from "react-input-mask";

interface updateDOBModalProps {
  onClose: Function;
  shouldShow: boolean;
}

interface updateDOBModalValues {
  dob: string;
}

const updateDOBModalSchema = yup.object().shape({
  dob: yup.string().required("Date of birth is required"),
});

export default function UpdateDOBModal({ onClose, shouldShow }: updateDOBModalProps) {
  const { control, errors, setValue, handleSubmit } = useForm<updateDOBModalValues>({
    resolver: yupResolver(updateDOBModalSchema),
    defaultValues: {
      dob: "",
    },
  });

  const userApi = useUserApi();
  const userAction = useAppUserAction();

  const onSubmit = (values: updateDOBModalValues) => {
    // console.log({values})
    let params = {
      dob: moment(values.dob).format("MM/DD/YYYY"),
    };
    userApi.callUpdateDob(
      params,
      (message: any, resp: any) => {
        userAction.updateDob(resp.dob);
        onClose();
        // console.log({resp})
      },
      (message: any) => {}
    );
  };

  return (
    <React.Fragment>
      <Modal
        show={shouldShow}
        backdrop="static"
        keyboard={false}
        className="dark-modal"
        centered
        contentClassName="custom-modal"
      >
        <Modal.Body>
          <div className="modal-body">
            <h4 className="rider-name-content">Please enter your date of birth</h4>
            <div className="mb-3">
              {/* <label className="form-label">Date Of Birth *</label> */}
              <Controller
                control={control}
                name="dob"
                render={({ onChange, onBlur, value, name, ref }) => (
                  <DateInput
                    onChange={(e) => {
                      onChange(e);
                    }}
                    onBlur={onBlur}
                    value={value}
                    maxDate={new Date()}
                    dateFormat={DATE_FORMAT}
                    inputRef={ref}
                    error={errors.dob}
                    // placeholder="Date of Birth"
                    placeholder="MM/DD/YYYY"
                    customInput={<ReactInputMask mask="99/99/9999" maskChar="_" />}
                  />
                )}
              />
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <div className="btn-wrap mb-3">
          <button className="btn btn-primary theme-primary-btn w-100 mt-4" 
              onClick={handleSubmit(onSubmit)}
            >
              Update
            </button>
          </div>
        </Modal.Footer>
      </Modal>
    </React.Fragment>
  );
}
